import React from "react";
import "../App.css";
const Loading = () => {
  return (
    <div className="load">
      <h2>Loading...</h2>
    </div>
  );
};

export default Loading;
